/*eslint-disable */
import Vue from 'vue';
var $ = window.jQuery = require('jquery');

// el: the element the directive is bound to.
// key: the keypath of the binding, excluding arguments and filters.
// arg: the argument, if present.
// expression: the raw, unparsed expression.
// vm: the context ViewModel that owns this directive.
// value: the current binding value.

Vue.directive('toggleblock',{
    bind: function (el, binding, vnode) {
            el.addEventListener('click', (event) => {
                event.preventDefault();
             
            let targetval = binding.value.target;
            $(targetval).toggleClass('show', 500);
            $(el).toggleClass('open')
        })
    },
    update: function (handler) {
        // the passed in value is a function
    },
    unbind: function () {
        // ...
    }
}
)